module.exports = __webpack_public_path__ + "img/third.6a5b7008.svg";